import { HospitalizationDTO } from 'utils';

export const HospitalizationOptions: HospitalizationDTO[] = [
  {
    display: 'Anaphylaxis',
    code: '39579001',
  },
  {
    display: 'Appendicitis',
    code: '74400008',
  },
  {
    display: 'Exacerbation of asthma',
    code: '281239006',
  },
  {
    display: 'Burn injury',
    code: '48333001',
  },
  {
    display: 'Cellulitis',
    code: '385627004',
  },
  {
    display: 'Human parturition, function',
    code: '386216000',
  },
  {
    display: 'Dehydration',
    code: '34095006',
  },
  {
    display: 'Diabetes type',
    code: '405751000',
  },
  {
    display: 'Disorder of digestive system',
    code: '53619000',
  },
  {
    display: 'Overdose',
    code: '1149222004',
  },
  {
    display: 'Febrile convulsion',
    code: '41497008',
  },
  {
    display: 'Fever',
    code: '386661006',
  },
  {
    display: 'Injury of head',
    code: '82271004',
  },
  {
    display: 'Influenza',
    code: '6142004',
  },
  {
    display: 'Jaundice',
    code: '18165001',
  },
  {
    display: 'Meningitis',
    code: '7180009',
  },
  {
    display: 'Problem behavior',
    code: '277843001',
  },
  {
    display: 'Injury due to motor vehicle accident',
    code: '407153006',
  },
  {
    display: 'Injury of musculoskeletal system',
    code: '105606008',
  },
  {
    display: 'Dysmorphism',
    code: '276720006',
  },
  {
    display: 'Pneumonia',
    code: '233604007',
  },
  {
    display: 'Poisoning',
    code: '75478009',
  },
  {
    display: 'Post-trauma response',
    code: '39093002',
  },
  {
    display: 'Prematurity of infant',
    code: '771299009',
  },
  {
    display: 'Mental disorder',
    code: '74732009',
  },
  {
    display: 'Disorder of respiratory system',
    code: '50043002',
  },
  {
    display: 'Respiratory syncytial virus infection',
    code: '55735004',
  },
  {
    display: 'Seizure',
    code: '91175000',
  },
  {
    display: 'Urinary tract infectious disease',
    code: '68566005',
  },
];
